import { initializeApiClient, setAccessToken } from "@template/api";
import { registerAuthRecovery, store } from "@template/state";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import { getRuntimeConfig } from "./config/runtime-config";

const config = getRuntimeConfig();

initializeApiClient({ baseUrl: config.apiBaseUrl });

// Re-hydrate the api-client's in-memory access token from whatever the auth
// slice loaded out of localStorage on startup (see auth.slice.ts).
setAccessToken(store.getState().auth.accessToken);

// Wires the api-client's single-flight 401-refresh-and-retry hook to this
// store. Must run once, before any authenticated request is made.
registerAuthRecovery(store);

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
